{
  "formats": {
    "date": "{{date, date}}",
    "longDate": "{{longDate, longDate}}",
    "longDateTime": "{{longDateTime, longDateTime}}",
    "time": "{{time, time}}",
    "number": "{{number, number}}"
  }
}
